export default "__VITE_ASSET__DWu3qmxo__"